import { programGenresContract } from '@mntn/api-contracts/flight-deck/v1/program-genres'
import { useFlightDeckTsRestClient } from '@/flight-deck-api/ts-rest'

export interface Genre {
  programGenreId: number
  name: string
}

export type GenresResponse = {
  data: Genre[]
}

export const useGenresService = () => {
  const programGenresClient = useFlightDeckTsRestClient(programGenresContract)

  return {
    getGenres: {
      handler: async () => {
        const response = await programGenresClient.list()

        if (response.status !== 200) {
          throw new Error('Failed to fetch genres')
        }

        return response.body
      },
    },
  }
}
